<p-dialog
  [(visible)]="showDialog"
  [modal]="true"
  [style]="{ margin: '0 2rem', minWidth: '300px' }"
  [draggable]="false"
  [closable]="modalData?.closable ?? true"
  [styleClass]="'info-modal'"
  (onHide)="handleHide()"
>
  <ng-template pTemplate="header">
    <div class="flex flex-column info-modal__header">
      <img
        [src]="modalData?.iconSrc || 'assets/icons/ico_alert_new.svg'"
        width="56"
        height="56"
        alt=""
      />
      <span class="t-20-700-primary mt-2">{{ modalData?.title || 'Información' }}</span>
    </div>
  </ng-template>
  <ng-template pTemplate="content">
    <p
      class="t-16-400-dark text-center"
      [innerHTML]="modalData?.message || 'Se ha producido una situación que requiere tu atención.'"
    ></p>
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="info-modal__footer" [ngClass]="{ 'info-modal__footer--single': !modalData?.cancelText }">
      <p-button
        *ngIf="modalData?.cancelText"
        [outlined]="true"
        [label]="modalData?.cancelText"
        (click)="cancel()"
      ></p-button>
      <p-button
        [label]="modalData?.buttonText || 'Aceptar'"
        (click)="confirm()"
      ></p-button>
    </div>
  </ng-template>
</p-dialog>
